import * as React from 'react';
const UnghiaIncarnitaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M90.31 93.86a13.67 13.67 0 0 1-4.01-9.7v-5.39c0-5.05 6.13-9.14 13.7-9.14.48 0 .94.02 1.4.05 0 0 1.71.14 4.18.74 1.85.55 3.49 1.37 4.8 2.39"
      className="prefix__cls-1"
    />
    <path
      d="M111.97 133.17a21.73 21.73 0 0 0-11.98-3.58 21.7 21.7 0 0 0-11.97 3.58M106.38 137.51a11.75 11.75 0 0 0-6.47-1.93c-2.39 0-4.61.71-6.47 1.93M120.56 119.56v18.78M79.44 138.34V85.75c0-12.14 7.29-24.08 20.56-24.09 8.21 0 14.19 4.69 17.51 11.15"
      className="prefix__cls-2"
    />
    <circle cx={114.7} cy={96.92} r={8.66} className="prefix__cls-1" />
    <circle cx={114.7} cy={96.92} r={1.24} className="prefix__cls-1" />
    <circle cx={114.7} cy={96.92} r={16.14} className="prefix__cls-1" />
  </svg>
);
export default UnghiaIncarnitaIcon;
